module.exports = __webpack_public_path__ + "static/img/0402_07.d845843.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/04/0402_07.png
// module id = rK+O
// module chunks = 1